import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { novoDB, triggerLoadNovoDB, unloadDb } from "../dbs/dbsSlice";
import { Box, Button, Card, Checkbox, Grid, List, ListItem, Stack, Typography } from "@mui/joy";
import { Link, Navigate } from "react-router-dom"
import { carregaWorkDB, setToEdit, updateWorks } from "./WorkSlice";
import { extrairTags, formatDateComHorasEhMinutos, stringDataFormatoJava } from "../helper/functions";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { novaConfirmacao, startConfirmacao } from "../helper/confirmation-modal/confirmationSlice";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

function retornaIndexPeloId(works, id) {
    for (var i = 0; i < works.length; i++) {
        if (works[i].id === id)
            return i;
    }

    return -1;
}

function WorkCard(props) {

    const {
        index,
        dragEnd,
        dragStart,
        dragEnter,
        cancelar,
        concluir,
        priorizar,
        editar,
        item } = props;

    const [state, setState] = useState({
        display: false
    });

    const toggleVisivel = () => {
        setState({ ...state, display: !state.display })
    }

    return <Card
        key={index}
        draggable
        onDragStart={() => dragStart(index)}
        onDragEnd={() => dragEnd(index)}
        onDragEnter={() => dragEnter(index)}
        onDragOver={(e) => e.preventDefault()}
        sx={{ marginBottom: "10px" }}
        className="work-row"
    >
        <Stack>
            <Stack direction="row">
                <Box sx={{ width: "100%" }}><Typography fontWeight={"lg"} color={"danger"}>{item.titulo}</Typography></Box>

                <DeleteIcon
                    className='work-edit-button'
                    sx={{ display: "none", cursor: "pointer", p: "0 4px" }}
                    onClick={() => cancelar(item.id)} />
                <EditIcon
                    className='work-edit-button'
                    sx={{ display: "none", cursor: "pointer", p: "0 4px" }}
                    onClick={() => editar(item.id)} />
                {!state.display && <AddIcon
                    sx={{ display: "block", cursor: "pointer", p: "0 4px" }}
                    onClick={() => toggleVisivel()} />}

                {state.display && <RemoveIcon
                    sx={{ display: "block", cursor: "pointer", p: "0 4px" }}
                    onClick={() => toggleVisivel()} />}
            </Stack>
            <Typography>{item.descricao}</Typography>
            {state.display && <Box><List marker={"upper-roman"}>
                {item.bullets.map((b, ind) => {
                    return <ListItem key={ind}>
                        <Stack direction={"row"} spacing={1} alignItems={"center"}>
                            <Typography fontWeight="lg">{b}</Typography>
                        </Stack>
                    </ListItem>
                })}
            </List>
                <Stack direction="row" spacing={1} sx={{ p: "0 0 5px 0" }}>
                    {extrairTags(item.hashtags).map((e, ind) => {
                        return <Box
                            key={ind}
                            sx={{
                                backgroundColor: "#333",
                                color: "#ddd",
                                padding: "2px 6px",
                                borderRadius: "5px"
                            }}>{e}</Box>
                    })}
                </Stack>
                <Box sx={{ p: "2px 0 0 0" }}>
                    <Typography>Created at: {formatDateComHorasEhMinutos(item.data)}</Typography>
                </Box>
                {item.dataCancelamento != null && <Box sx={{ p: "1px 0 0 0" }}>
                    <Typography>Cancelled at: {formatDateComHorasEhMinutos(item.dataCancelamento)}</Typography>
                </Box>}
                {item.dataConclusao != null && <Box sx={{ p: "1px 0 0 0" }}>
                    <Typography>Concluido at: {formatDateComHorasEhMinutos(item.dataConclusao)}</Typography>
                </Box>}
                <Stack direction="row" spacing={1} sx={{ p: "4px 0 0 0" }}>
                    <Checkbox checked={item.dataConclusao !== null} label="Concluir" onClick={() => concluir(item.id)} />
                    <Checkbox checked={item.dataPriorizacao !== null} label="Priorizar" onClick={() => priorizar(item.id)} />
                </Stack>
            </Box>}
        </Stack>

    </Card>
}

function ListaWork(props) {

    var dispatch = useDispatch();
    var toEdit = useSelector((state) => state.work.toEdit);
    var dragStart = (index) => { }
    var dragEnd = (index) => { }
    var dragEnter = (index) => { }

    const passaNoFiltro = (a) => {

        switch (props.filtro.tipo) {
            case "CONCLUIDOS":
                return a.dataConclusao !== null;
            case "PRIORIZADOS":
                return a.dataPriorizacao !== null &&
                a.dataCancelamento === null &&
                a.dataConclusao === null;
            case "CANCELADOS":
                return a.dataCancelamento !== null;
            case "ATIVOS":
                return a.dataCancelamento === null &&
                    a.dataConclusao === null
            default:
                return true;
        }

    }

    const editar = (id) => {
        dispatch(setToEdit(id));
    }

    if (toEdit !== null) {
        return <Navigate to={"/work/add"} />
    }

    return <Grid xs={12}>
        {props.works
            .filter(a => passaNoFiltro(a))
            .map((a, index) =>
                <WorkCard
                    key={index}
                    index={index}
                    dragEnd={dragEnd}
                    dragStart={dragStart}
                    dragEnter={dragEnter}
                    cancelar={props.cancelar}
                    concluir={props.concluir}
                    priorizar={props.priorizar}
                    editar={editar}
                    item={a} />
            )}
    </Grid>;
}

function ControlPanel(props) {
    return <Grid xs={12}
        sx={{ marginBottom: "10px" }}>
        <Stack direction="row" spacing={2}>
            <Link to="/work/add">
                <Button >Adicionar</Button>
            </Link>
            <Link onClick={() => props.atualizar()}>
                <Button color="danger">Atualizar</Button>
            </Link>
        </Stack>
    </Grid>
}

function ControlPanelFiltros(props) {
    return <Grid xs={12}
        sx={{ marginBottom: "10px" }}>
        <Stack direction="row" spacing={1}>
            <Typography>Filtros:</Typography>
            {["ATIVOS", "TODOS", "CONCLUIDOS", "PRIORIZADOS", "CANCELADOS"]
                .map((a, index) => {
                    var style = {
                        backgroundColor: "#8d8c8cff",
                        color: "#ddd",
                        padding: "2px 12px",
                        borderRadius: "5px",
                        cursor: "pointer"
                    }


                    if (props.filtro.tipo == a) {
                        style = {
                            ...style,
                            backgroundColor: "#0d770dff",
                        }
                    }

                    return <Box
                        key={index}
                        onClick={() => props.filtrar(a)}
                        sx={style}>{a}</Box>
                })}
        </Stack>
    </Grid>
}

function WorkMainPage() {

    var dispatch = useDispatch()
    var loaded = false
    var dbs = useSelector((state) => state.dbs.dbs)
    var works = useSelector((state) => state.work.db.works)

    const toggleCancelar = (id) => {
        console.log("Cancelando: ", id);
        var index = retornaIndexPeloId(works, id);
        var nWork = JSON.parse(JSON.stringify(works[index]));

        dispatch(startConfirmacao(novaConfirmacao("Deseja cancelar o: " + nWork.titulo + "?", () => {
            nWork.dataCancelamento = stringDataFormatoJava(new Date())
            var nWorks = JSON.parse(JSON.stringify(works));

            nWorks[index] = nWork;
            dispatch(updateWorks(nWorks));
        })))
    }

    const toggleConcluir = (id) => {
        // console.log("Concluir", index)
        var nWorks = JSON.parse(JSON.stringify(works));
        var index = retornaIndexPeloId(nWorks, id);

        nWorks[index].dataConclusao = nWorks[index].dataConclusao === null ?
            nWorks[index].dataConclusao = stringDataFormatoJava(new Date()) : null;
        dispatch(updateWorks(nWorks));
    }

    const togglePriorizar = (id) => {
        var nWorks = JSON.parse(JSON.stringify(works));
        var index = retornaIndexPeloId(nWorks, id);

        nWorks[index].dataPriorizacao = nWorks[index].dataPriorizacao === null ?
            nWorks[index].dataPriorizacao = stringDataFormatoJava(new Date()) : null;
        dispatch(updateWorks(nWorks));
    }

    if (Object.keys(dbs).includes("work")) {
        loaded = dbs.work.loaded
    }

    const wait = async () => {
        await new Promise(resolve => setTimeout(resolve, 100)); // Espera 1 segundo
    };

    const atualizar = async () => {
        loaded = false
        dispatch(unloadDb("work"))
        await wait();
        startLoad();
    }

    const startLoad = async () => {
        dispatch(triggerLoadNovoDB(
            novoDB("work", 10, "db", (p) => {

                var db = p.payload
                var versao = p.versao

                dispatch(carregaWorkDB(db))
            })
        ))
    }

    var [filtro, setFiltro] = useState({
        tipo: "PRIORIZADOS",
    })

    const filtrar = (f) => {
        setFiltro({ ...filtro, tipo: f })
    }

    React.useEffect(() => {
        startLoad();
    }, []);

    if (!loaded) return <Carregando />

    return <Grid container sx={{ padding: "5px 10px" }}>

        <ControlPanel atualizar={atualizar} />
        <ControlPanelFiltros filtro={filtro} filtrar={filtrar} />
        <ListaWork
            works={works}
            cancelar={toggleCancelar}
            concluir={toggleConcluir}
            priorizar={togglePriorizar}
            filtro={filtro} />

    </Grid>
}

function Carregando() {
    return <Grid container>
        <Grid xs={12} sx={{
            diplay: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center"
        }}>
            Experando banco de dados...
        </Grid>
    </Grid>
}
export default WorkMainPage;